module.exports = __webpack_public_path__ + "img/SGAK.17915f0d.jpg";